/* TODO:
  enable organizing and renaming
  add toggle for Notification Bubble
*/

import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";

// material ui core imports
import {
  Grid,
  Checkbox,
  IconButton,
  TextField,
} from "@material-ui/core";

// component imports
import {
  RegularCard,
  ItemGrid,
} from "../../components";

// the iPhone that displays how the application will look
import IPhone from './iphone';

// reducer action imports
import {
  loadHome,
  editHome,
} from './reducer/actions';

import {
  loadTheme,
} from '../General/reducer/actions';

import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import UpIcon from '@material-ui/icons/ArrowUpward';
import DownIcon from '@material-ui/icons/ArrowDownward';

// default names of each component
const defaults = {
  sports: "ATHLETICS",
  friends: "COMMUNITY",
  coupons: "COUPONS",
  eventcard: "EVENTS",
  pagebuttons: "LINKS",
  locationcard: "LOCATIONS",
  lotto: "LOTTERY",
  newscard: "NEWS",
  announcements: "NOTIFICATIONS",
  loyalty: "REWARDS",
  socialmedia: "SOCIAL MEDIA",
  specialcard: "SPECIALS",
  dayevents: "TODAY",
};

// You're looking at Now, sir. Everything that's happening Now, is happening Now.
// What happened to Then?
// You missed it.
// When?
// Just now.

// Home view - add and reorganize app front page components
class HomeView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      index: -1,
      isEditing: false,
      name: '',
    }
  }

  // load in Settings/Home when page is opened
  componentDidMount () {
    this.props.loadHome();
    this.props.loadTheme();
  }

  // successful change
  onSuccess() {
    console.log('Design successfully saved!');
  }

  // unsuccessful change
  onError(error) {
    console.log(error);
  }

  // toggle a component on or off
  changeComponent(checked, type, name, index) {
    var home = this.props.home;
    // if it's currently On, turn it Off
    if (checked) {
      home.splice(index, 1);
    }
    // if it's currently Off, add it to the end of Home
    else {
      home.push({
        key: type,
        value: name
      })
    }
    home = { "home": home };
    // call edit
    this.props.editHome(
      home,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  // move a component further up the home screen
  moveComponentUp(index) {
    // cannot be moved any further, return
    if (index === 0) {
      return;
    }
    var home = this.props.home;
    // swap with index above
    var above = index - 1;
    var swap = home[index];
    home[index] = home[above];
    home[above] = swap;
    home = { "home": home };
    // edit
    this.props.editHome(
      home,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  // move a component down the home screen
  moveComponentDown(index) {
    var home = this.props.home;
    // cannot go down any more, return
    if (home.length <= index + 1) {
      return;
    }
    // swap with index below
    var below = index + 1;
    var swap = home[index];
    home[index] = home[below];
    home[below] = swap;
    home = { "home": home };
    // edit
    this.props.editHome(
      home,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  // enable editing component or stop editing component
  initEditComponent(index) {
    if (this.state.index === index) {
      this.setState({index: -1, isEditing: false, name: ''});
    }
    else {
      this.setState({index: index, isEditing: true, name: ''});
    }
  }

  // finish editing component
  submitEditComponent() {
    var home = this.props.home;
    home[this.state.index].value = this.state.name;
    home = { "home": home };
    this.props.editHome(
      home,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
    this.setState({index: -1, isEditing: false, name: ''})
  }

  // displays the main body to enable editing
  showEditor() {
    // Components contains whether boxes are checked or not
    var components = this.props.components;
    // List of components' custom names
    const list = this.props.list;
    // array to be returned
    var boxes = [];
    // iterate through List
    for (let k = 0; k < list.length; ++k) {
      // type of component
      let type = list[k].key;
      // given name of component
      let name = list[k].value;
      // whether component has been enabled or not
      let checked = components[type];
      // add checkbox and text
      // TODO: if Checked, add up/down buttons, edit field
      boxes.push(
        <ItemGrid xs={4}>
          <Checkbox
            checked={checked}
            onChange={()=>{
              this.changeComponent(checked, type, name, k)
            }}
          />
          <span style={{paddingLeft: 15}}>
            { name }
          </span>
        </ItemGrid>
      );
      if (checked) {
        boxes.push(
          <ItemGrid xs={5}>
            <IconButton tooltip="Move component up"
              onClick = {(e) => {this.moveComponentUp(k)}}>
              <UpIcon />
            </IconButton>
            <IconButton tooltip="Move component down"
              onClick = {(e) => {this.moveComponentDown(k)}}>
              <DownIcon />
            </IconButton>
            <IconButton tooltip="Edit Component Name"
              onClick={(e) => {this.initEditComponent(k)}}>
              <EditIcon />
            </IconButton>
          </ItemGrid>
        )
      }
      // if Editing has been activated, show this block
      if (this.state.index === k && this.state.isEditing) {
        boxes.push(
          <ItemGrid xs={3}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <TextField
                id='name'
                label='Name'
                value={this.state.name}
                onChange={(e)=>this.setState({name: e.target.value})}
              />
              <IconButton tooltip="Submit Edit"
                onClick={(e) => {this.submitEditComponent()}}>
                <CheckIcon />
              </IconButton>
            </div>
          </ItemGrid>
        );
      }
    }
    // return boxes
    return (
      <Grid container>
        { boxes }
      </Grid>
    );
  }

  // turn notification bubble off and on
  switchNotif() {
    var notif = this.props.bubble;
    if (!notif) {
      notif = true;
    }
    else {
      notif = false;
    }
    notif = { "bubble": notif};
    this.props.editHome(
      notif,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  // turn migrate feature off and on
  switchMigrate() {
    var migrate = this.props.migrate;
    if (!migrate) {
      migrate = true;
    }
    else {
      migrate = false;
    }
    migrate = { "migrate": migrate};
    this.props.editHome(
      migrate,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  // turn migrate feature off and on
  switchLocation() {
    var location = this.props.locationEnabled;
    if (!location) {
      location = true;
    }
    else {
      location = false;
    }
    let enabled = { "locationEnabled": location};
    this.props.editHome(
      enabled,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }


  // bottom segment for other app features
  appSettings() {
    return (
      <Grid>
        <ItemGrid xs={12}>
          <div style={{
            width: '100%',
            height: 5,
            borderRadius: 3,
            backgroundColor: 'gray',
            marginTop: 20,
            marginBottom: 20,
          }}/>
        </ItemGrid>
        <ItemGrid xs={12}>
          <Checkbox
            checked={this.props.bubble}
            onChange={()=>{
              this.switchNotif()
            }}
          />
          <span style={{paddingLeft: 15}}>
            Enable Notification Bubble
          </span>
        </ItemGrid>
        <ItemGrid xs={12}>
          <Checkbox
            checked={this.props.migrate}
            onChange={()=>{
              this.switchMigrate()
            }}
          />
          <span style={{paddingLeft: 15}}>
            Enable Account Migration
          </span>
        </ItemGrid>
        <ItemGrid xs={12}>
          <Checkbox
            checked={this.props.locationEnabled}
            onChange={()=>{
              this.switchLocation()
            }}
          />
          <span style={{paddingLeft: 15}}>
            Enable Geo Checkin
          </span>
        </ItemGrid>
      </Grid>
    )
  }

  // render the page
  render() {
    // make sure only authorized Users proceed
		// check for admin rights in general
		if (!this.props.user.hasOwnProperty('admin')) {
			return (
				<Redirect from={'settings'} to={'dashboard'} key={'invalid'} />
			);
		}
		// only master admins can view this page
		if (!this.props.user.admin.master)
		{
			return (
				<Redirect from={'settings'} to={'dashboard'} key={'noTicket'} />
			);
		}

    // render return
    return (
    <Grid container>
      {/* Settings editing on left */}
      <ItemGrid xs={8}>
        <RegularCard
          cardTitle="Settings"
          cardSubtitle="Rearrange Home screen and toggle features."
          content={
            <div>
            <Grid container>
              {this.showEditor()}
            </Grid>
              {this.appSettings()}
            </div>
          }
        />
      </ItemGrid>
      {/* iPhone that displays layout on right */}
      <ItemGrid xs={4}>
        <IPhone theme={this.props.theme} home={this.props.home}/>
      </ItemGrid>
    </Grid>
    );
  }
}

HomeView.propTypes = {
  classes: PropTypes.object.isRequired
};

// map state to props
const mapStateToProps = (state) => {
  // names of components that front end can use
  // in this order so that, combined with Default above
  // will render default component names in alphabetical order
  var names = [
    'sports',
    'friends',
    'coupons',
    'eventcard',
    'pagebuttons',
    'locationcard',
    'lotto',
    'newscard',
    'announcements',
    'loyalty',
    'socialmedia',
    'specialcard',
    'dayevents',
  ];

  // stores which components have been turned on
  var components = {
    announcements: false,
    coupons: false,
    dayevents: false,
    eventcard: false,
    friends: false,
    locationcard: false,
    lotto: false,
    loyalty: false,
    newscard: false,
    pagebuttons: false,
    specialcard: false,
    socialmedia: false,
    sports: false
  };

  // get settings value
  var home = state.homeReducer.settings;
  var migrate = false;
  var bubble = false;
  var locationEnabled = false;
  if (home.hasOwnProperty('migrate')) {
    migrate = home.migrate;
  }
  if (home.hasOwnProperty('bubble')) {
    bubble = home.bubble;
  }
  if (home.hasOwnProperty('locationEnabled')) {
    locationEnabled = home.locationEnabled;
  }
  if (home.hasOwnProperty('home')) {
    home = home.home;
  }
  if (!home || !Array.isArray(home)) {
    home = [];
  }

  // iterate through Home and see what components have been added
  for (let c = 0; c < home.length; ++c) {
    let component = home[c].key;
    components[component] = true;
    // remove existing components from Names
    let index = names.indexOf(component);
    names.splice(index, 1);
  }

  // copy home to create a printable list of check boxes
  var list = home.slice(0, home.length);

  // add the remaining default names
  for (let k = 0; k < names.length; ++k) {
    list.push({key: names[k], value: defaults[names[k]]});
  }

  var theme = state.themeReducer.theme;
  if (typeof theme === 'string') {
    theme = JSON.parse(theme);
  }

  // and return
  return {
    components: components,
    user: state.authReducer.user,
    loggedIn: state.authReducer.loggedIn,
    theme: theme,
    home: home,
    list: list,
    bubble: bubble,
    migrate: migrate,
    locationEnabled: locationEnabled,
  };
}

const mapDispatchToProps = {
  loadHome,
  editHome,
  loadTheme,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);
